// src/i18n/dates.js
// Formats de date selon la langue courante (heures toujours en Europe/Paris, cf. CLAUDE.md).
//   localeDateFns() → locale date-fns, à passer à `format(…, { locale: localeDateFns() })`
//   localeIntl()    → code BCP 47 pour toLocaleString / Intl ('fr-FR', 'en-GB'…)
import { fr, enGB, it, es, de } from 'date-fns/locale';
import { i18n } from './index';

const DATEFNS = { fr, en: enGB, it, es, de };
const INTL = { fr: 'fr-FR', en: 'en-GB', it: 'it-IT', es: 'es-ES', de: 'de-DE' };

export const localeDateFns = () => DATEFNS[i18n.global.locale.value] || fr;
export const localeIntl = () => INTL[i18n.global.locale.value] || 'fr-FR';

// Heure de Paris quel que soit le fuseau du navigateur (02/10/2026 : jusqu'ici, un utilisateur à
// l'étranger — ou un poste réglé en UTC — lisait ses alarmes dans son heure locale).
//   Intl / toLocale*  → passer `timeZone: FUSEAU` dans les options ;
//   date-fns `format` → formater `enParis(date)` : une Date dont les champs LOCAUX valent
//                       l'heure de Paris (date-fns ne connaît pas les fuseaux).
export const FUSEAU = 'Europe/Paris';
const champs = new Intl.DateTimeFormat('en-US', {
  timeZone: FUSEAU, hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit'
});
export function enParis(date) {
  const d = date instanceof Date ? date : new Date(date);
  if (isNaN(d)) return d;
  const p = Object.fromEntries(champs.formatToParts(d).map(x => [x.type, x.value]));
  return new Date(+p.year, +p.month - 1, +p.day, +p.hour, +p.minute, +p.second, d.getMilliseconds());
}
